// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.content[data-v-50d31597] {\n  margin-top: 8px;\n}\nvwc-dialog[data-v-50d31597] {\n  --mdc-dialog-z-index: 100000;\n}\n", ""]);
// Exports
module.exports = exports;
